import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createJournalEntry = ({ churchId, journalEntryData }) => {
  return axios.post(`/churches/${churchId}/journal-entries`, journalEntryData);
};

export const useCreateJournalEntry = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("journal-entries");

      setNotification({
        type: "success",
        message: "Journal entry created successfully!"
      });
    },
    ...config,
    mutationFn: createJournalEntry
  });
};
